import React from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Calendar, MapPin, Clock, Ticket } from 'lucide-react';

const Events = ({ eventsData }) => {
  if (!eventsData || eventsData.length === 0) return null;

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  };

  const getEventIcon = (type) => {
    switch (type) {
      case 'performance':
        return <Ticket className="w-6 h-6" />;
      case 'workshop':
        return <Calendar className="w-6 h-6" />;
      case 'collaboration':
        return <MapPin className="w-6 h-6" />;
      default:
        return <Calendar className="w-6 h-6" />;
    }
  };

  return (
    <section id="events" className="py-24 px-6 relative overflow-hidden bg-black">
      <div className="container mx-auto max-w-6xl relative z-10">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 px-4 py-2 rounded-full bg-[#D4AF37]/10 border border-[#D4AF37]/30 mb-6">
            <Calendar className="w-4 h-4 text-[#D4AF37]" />
            <span className="text-sm font-medium text-white" style={{ fontFamily: 'Montserrat, sans-serif' }}>Events</span>
          </div>
          
          <h2 className="text-5xl md:text-6xl font-bold mb-6 text-white" style={{ fontFamily: 'Cinzel, serif' }}>
            Upcoming Gatherings
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Join the journey through live performances and workshops
          </p>
        </div>

        <div className="space-y-6">
          {eventsData.map((event) => (
            <Card 
              key={event.id}
              className="bg-black border-2 border-[#D4AF37]/20 hover:border-[#D4AF37]/50 transition-all duration-300 group"
            >
              <CardContent className="p-8">
                <div className="grid md:grid-cols-[auto_1fr_auto] gap-6 items-center">
                  {/* Event Icon */}
                  <div className="flex items-center justify-center w-16 h-16 bg-[#D4AF37]/10 border-2 border-[#D4AF37]/30 group-hover:border-[#D4AF37] transition-colors">
                    <div className="text-[#D4AF37]">
                      {getEventIcon(event.type)}
                    </div>
                  </div>
                  
                  {/* Event Details */}
                  <div className="space-y-3">
                    <div>
                      <div className="text-xs uppercase tracking-wider text-[#D4AF37] mb-2" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                        {event.type}
                      </div>
                      <h3 className="text-2xl font-bold text-white mb-2" style={{ fontFamily: 'Cinzel, serif' }}>
                        {event.title}
                      </h3>
                      <p className="text-gray-400 leading-relaxed">
                        {event.description}
                      </p>
                    </div>
                    
                    <div className="flex flex-wrap gap-4 text-sm text-gray-400">
                      <div className="flex items-center space-x-2">
                        <MapPin className="w-4 h-4 text-[#D4AF37]" />
                        <span>{event.venue}</span>
                      </div>
                      <div className="flex items-center space-x-2">
                        <Calendar className="w-4 h-4 text-[#D4AF37]" />
                        <span>{formatDate(event.date)}</span>
                      </div>
                      <div className="flex items-center space-x-2">
                        <Clock className="w-4 h-4 text-[#D4AF37]" />
                        <span>{event.time}</span>
                      </div>
                    </div>
                  </div>
                  
                  {/* Action Button */}
                  <Button
                    className="bg-[#D4AF37] hover:bg-[#FFB547] text-black border-0 font-semibold whitespace-nowrap"
                    onClick={() => alert('RSVP functionality would be connected here')}
                  >
                    Get Tickets
                  </Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
        
        <div className="mt-12 text-center">
          <p className="text-gray-400 mb-4">
            Want to stay updated on upcoming events?
          </p>
          <Button
            variant="outline"
            className="border-2 border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-black font-semibold"
            onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
          >
            Join the Newsletter
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Events;